export const ISSUE_TOPICS = Object.freeze([
  Object.freeze({ value: "deposit", label: "แจ้งปัญหาเติมเงิน" }),
  // Object.freeze({ value: "line_change", label: "ต้องการเปลี่ยน user LINE" }),
  // Object.freeze({ value: "register_issue", label: "สมัครบัญชีไม่ได้" }),
]);

export const DEFAULT_TOPIC = "deposit";
